// extracted by mini-css-extract-plugin
export default {"company-header":"Header_company-header__0bLvO","company-header-item":"Header_company-header-item__0pOXq"};